<div class="functions">
  @for (row of rows(); track row.uid; let index = $index) {
    <div class="gap-8">
      <h2 class="mb-8">Function {{ index + 1 }}</h2>
      <blaze-openai-connector-function
        [function]="row.function"
        (removeFunction)="removeFunction(row.uid)"
        (functionChange)="updateFunction(row.uid, $event)"
        (isValid)="setFunctionValidity(row.uid, $event)"
      />
    </div>
  }

  <button
    blazeButton
    buttonStyle="primary"
    blazeButtonSize="lg"
    class="uppercase w-[180px]"
    (click)="addFunction()"
  >
    Add new function
  </button>
</div>
